class ImageCollage extends HTMLElement {
  constructor() {
    super();
    this.mql = window.matchMedia('(min-width: 750px)');
    this.updateHeights();
    window.addEventListener('resize', this.updateHeights.bind(this));
  }

  updateHeights() {
    const topBlock = this.querySelector('.js-image-collage-top-block');

    if (!topBlock) return;

    this.querySelectorAll('.js-image-collage-bottom-block').forEach((block) => {
      block.style.height = this.mql.matches ? topBlock.offsetHeight + 'px' : 'auto';
    });
  }
}

if (!customElements.get('image-collage')) {
  customElements.define('image-collage', ImageCollage);
}
